import retrieveDaqsJson from './retrieve-daqs-json'
import tableAdapter from './tableAdapter'
import boatTypes from './filters/boatTypes'
import { components } from '@datavue/datavue-ui'
import statesWithRegions from './filters/statesWithRegions'
const ChloroplethHeatmap = () =>
  import('../components/charts/ChloroplethHeatmap')
const HorizontalBarchart = () =>
  import('../components/charts/HorizontalBarchart')
const GenericPage = () => import('@/components/pages/GenericPage')
const DaqsChart = () => import('@/components/DaqsChart')
export default class Ownership {
  title = 'Recreational Boat Ownership In the U.S.: Overview'
  key = 'ownership'
  pageComponent = GenericPage
  retrieveData = retrieveDaqsJson
  filters = function () {
    return {
      filter1boattype: {
        label: 'Boat Type:',
        component: components['DatavueUiSelect'],
        options: boatTypes
      },
      filter2stateorregion: {
        label: 'State/Region:',
        component: components['DatavueUiSelect'],
        options: statesWithRegions
      },
      measure: {
        label: 'Display Results As:',
        component: components['DatavueUiRadioGroup'],
        props: {
          inline: true
        },
        options: [
          {
            key: 'count',
            label: 'Number (In 1000s)',
            default: true
          },
          {
            key: 'percent',
            label: 'Percent'
          }
        ]
      }
    }
  }
  charts = function () {
    return {
      overall_boats_owned: {
        title: 'Boats Owned',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      overall_boats_registered: {
        title: 'Registered Boats Owned',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      overall_boats_unregistered: {
        title: 'Unregistered Boats Owned',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      overall_operational: {
        title: 'Operational Boats Owned',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      state_of_boat: {
        title: 'Boats Owned By State Of Boat Registration/Storage',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          grid: 'map',
          tableLabel: 'State Of Boat Registration/Storage',
          tableAdapter: tableAdapter
        }
      },
      region_of_boat: {
        title: 'Boats Owned By Region of Boat Registration/Storage',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'region',
          grid: 'map',
          tableLabel: 'Region Of Boat Registration/Storage',
          tableAdapter: tableAdapter
        }
      },
      boattype: {
        title: 'Boats Owned By Boat Type',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableLabel: 'Boat Type',
          tableAdapter: tableAdapter
        }
      },
      storage_location: {
        title: 'Operated Boats Owned by Storage Location',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableLabel: 'Storage Location',
          tableAdapter: tableAdapter
        }
      },
      overall_boat_owning_households: {
        title: 'Households That Owned Boats',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'household_overall'
        }
      },
      household_boats_registration: {
        title: 'Households That Owned Boats By Boat Registration Status',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'household_other',
          tableLabel: 'Registration Status',
          tableAdapter: tableAdapter
        }
      }
    }
  }
}
